import { types } from 'mobx-state-tree';

import TrafficConvictionTypeValues from '../definitions/TrafficConvictionTypeValues';


const TrafficConviction = types
    .model('TrafficConviction', {
        id: types.identifier,
        type: types.enumeration(
            Object.values(TrafficConvictionTypeValues),
        ),
        date: types.string,
    });

export default TrafficConviction;
